// Load libraries
async function loadLibraries() {
    try {
        // Load Alpine.js from CDN
        const alpineScript = document.createElement('script')
        alpineScript.src = 'https://unpkg.com/alpinejs@3.14.9/dist/cdn.min.js'
        alpineScript.defer = true
        document.head.appendChild(alpineScript)

        // Load Feather icons from local file
        const featherScript = document.createElement('script')
        featherScript.src = '/static/js/feather.min.js'
        
        await new Promise((resolve) => {
            featherScript.onload = resolve
            document.head.appendChild(featherScript)
        })
        
        // Initialize Feather icons
        if (window.feather) {
            initializeFeather()
        }

        // Load theme toggle
        import('./theme-toggle.js')
            .catch(err => console.error('Failed to load theme-toggle:', err))

    } catch (error) {
        console.error('Error loading libraries:', error)
    }
}

function initializeFeather() {
    window.feather.replace()
}

// Initialize everything
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadLibraries)
} else {
    loadLibraries()
}